import { render, staticRenderFns } from "./TabelaPrecoList.vue?vue&type=template&id=7e208a70"
import script from "./TabelaPrecoList.vue?vue&type=script&lang=js"
export * from "./TabelaPrecoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports